import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageDataTypes, PageTypes } from '@/store/types/pageTypes';


const initialPageState: PageDataTypes = {
	title: '',
	description: '',
	canonical: '',
};

const initialState: PageTypes = {
	data: initialPageState,
};

const pageSlice = createSlice({
	name: 'page',
	initialState,
	reducers: {
		setPageData(state, action: PayloadAction<PageDataTypes>) {
			state.data = action.payload;
		},
		resetPageData(state) {
			state.data = initialState.data;
		},
	},
});

export const { setPageData, resetPageData } = pageSlice.actions;

export default pageSlice.reducer;
